var callback = function () {
  // Background Music toggle functionality
  const bgAudio = document.querySelector(".bgAudio");
  if (bgAudio) {
    bgAudio.play();
  }

  const toggleButton = document.querySelector(".toggleMusic");
  toggleButton && toggleButton.addEventListener("click", function (e) {
    if (bgAudio && bgAudio.paused) {
      e.target.innerText = "Stop Music";
      bgAudio.play();
    } else {
      e.target.innerText = "Play Music";
      bgAudio.pause();
    }
  });

  // Handler when the DOM is fully loaded
  // wait for images to be downloaded and start the animation
  function stopAudio(audio) {
    audio.pause();
    audio.currentTime = 0;
  }

  function handleAudio(event) {
    document.querySelectorAll("audio").forEach((item) => {
      if (item) stopAudio(item);
    });
    if (event && event.currentTarget && event.currentTarget.id)
      document.querySelector("." + event.currentTarget.id).play();
  }

  const images = document.querySelectorAll("img");

  Promise.all(
    Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve(img.naturalHeight !== 0);
      return new Promise((resolve) => {
        img.addEventListener("load", () => resolve(true));
        img.addEventListener("error", () => resolve(false));
      });
    })
  ).then((results) => {
    if (results.every((res) => res)) {
      new Glider(document.querySelector(".glider"), {
        slidesToShow: 1,
        duration: 0.2,
        draggable: false,
        arrows: {
          prev: ".glider-prev",
          next: ".glider-next",
        },
      });

      document.querySelectorAll(".flower").forEach((item) => {
        if (item) item.addEventListener("click", handleAudio);
      });
    } else console.log("Some images failed to load, all finished loading");
  });
};

if (
  document.readyState === "complete" ||
  (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener("DOMContentLoaded", callback);
}
